import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store'
import { useGetUserQuery } from '../services/user'

/** Keep auth.user in sync with backend after login. */
export function useHydrateUser() {
  const userId = useSelector((s: RootState) => s.auth.user?._id)
  const token = useSelector((s: RootState) => s.auth.accessToken)
  useGetUserQuery(userId!, { skip: !userId || !token })
}

export function useAuthGate() {
  const accessToken = useSelector((s: RootState) => s.auth.accessToken)
  const user = useSelector((s: RootState) => s.auth.user)
  return { isAuthenticated: Boolean(accessToken), user, accessToken }
}

/** Soft refetch vehicles on focus / interval for live feel. */
export function useVehiclesPoll(refetch: () => void, ms = 30_000) {
  useEffect(() => {
    const id = window.setInterval(() => refetch(), ms)
    const onFocus = () => refetch()
    window.addEventListener('focus', onFocus)
    return () => {
      window.clearInterval(id)
      window.removeEventListener('focus', onFocus)
    }
  }, [refetch, ms])
}
